import React from 'react';
import { BarDatum } from '../stats';
import { Currency, Money } from 'rpc/model/squareup/connect/v2/common/money';
import { formatConnectMoney } from 'utils/currency';
import { theme } from 'tailwind.config';

type HorizontalBarChartProps = {
  data: BarDatum[];
  currency: Currency;
  emptyText?: string;
};

const HorizontalBarChart: React.FC<HorizontalBarChartProps> = ({
  data,
  currency,
  emptyText = 'No data yet.',
}) => {
  if (data.length === 0) {
    return <p className="paragraph-20 text-grey my-0">{emptyText}</p>;
  }

  const max = Math.max(...data.map((datum) => datum.amount), 1);

  return (
    <ul className="flex flex-col gap-4 list-none p-0 m-0">
      {data.map((datum) => {
        const widthPct = Math.max((datum.amount / max) * 100, 2);
        return (
          <li key={datum.label}>
            <div className="flex items-center justify-between mb-1 gap-2">
              <div className="flex items-center min-w-0">
                {datum.imageUrl && (
                  <img
                    alt=""
                    src={datum.imageUrl}
                    className="w-5 h-5 rounded mr-2 flex-none object-cover"
                  />
                )}
                <span className="font-medium truncate">{datum.label}</span>
              </div>
              <span className="paragraph-20 flex-none">
                {formatConnectMoney(
                  Money.create({ amount: datum.amount, currency })
                )}
              </span>
            </div>
            <div
              className="w-full rounded-full h-2"
              style={{ backgroundColor: theme.extend.colors.emphasis40 }}
            >
              <div
                className="h-2 rounded-full"
                style={{
                  backgroundColor: theme.extend.colors.blue,
                  width: `${widthPct}%`,
                }}
              />
            </div>
            {datum.sublabel && (
              <div className="paragraph-20 text-grey mt-1">
                {datum.sublabel}
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default HorizontalBarChart;
